import { Alert, AlertHeading } from '@edgebox/react-components';
import React from 'react';
import { SITE_DRAFT_REVIEW_TITLE_COPY } from './siteDraftNotice';

/**
 * The notice for a draft the site wrote while it awaits the review: the design system's alert, titled by a heading
 * a screen reader can find, with the body
 * of the screen showing it, because the page's own screen in the site and the page detail in the App each say where
 * the draft is published.
 */
export function SiteDraftReviewNotice({ body }: { body: string }) {
  return (
    <Alert variant="success">
      <AlertHeading role="heading" aria-level={2}>
        {SITE_DRAFT_REVIEW_TITLE_COPY}
      </AlertHeading>
      <p className="mb-0">{body}</p>
    </Alert>
  );
}
